module.exports = __webpack_public_path__ + "img/k2.618228c7.webp";